export enum MessageStatus {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}
